@if (superTenant) {
  <div class="super-tenants default-content mb-4">
    <h3 class="text-uppercase"><small><strong i18n="@@components.tenant_settings.super_tenant">Super Tenant</strong></small></h3>
    <fa-icon [icon]="['fas', 'university']"
      [fixedWidth]="true">
    </fa-icon> {{ superTenant.name }}
  </div>
}
